import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { CanActivate } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { PublicDataService } from '../core/services';

@Injectable({
  providedIn: 'root',
})
export class LanguageGuard implements CanActivate {
  language: string;
  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    private translate: TranslateService,
    private readonly publicData: PublicDataService
  ) {
    this.language = '';
  }

  canActivate(): Observable<any> {
    if (isPlatformBrowser(this.platformId)) {
      if (localStorage.getItem('language') != undefined) {
        this.language = localStorage.getItem('language') || '';
      } else {
        localStorage.setItem('language', 'es');
      }

      switch (this.language) {
        case 'es':
          this.translate.use('es');
          this.publicData.idioma = 'esp';
          break;
        case 'en':
          this.translate.use('en');
          this.publicData.idioma = 'eng';
          break;
        default:
          this.translate.use('es');
          this.publicData.idioma = 'esp';
          break;
      }
    }

    return of(true);
  }
}
